module.exports = __webpack_public_path__ + "static/9-7b9cb838cfc98bb526c3aaf6431252b1.jpg";